module.exports = __webpack_public_path__ + "static/food-fair-a476cff9191a17a4f5e584516de042e2.jpg";